import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { IGrillOption } from "../../contexts/ConfigContext/types";
import PopupDialog from "../elements/PopupDialog/PopupDialog";
import "./GrillSelectionModal.scss";

interface IGrillSelectionModalProps {
	grillOptions: IGrillOption[];
	onConfirm: (grillId: string | null) => void;
	initialSelected?: string | null;
	onClose?: () => void;
}

const GrillSelectionModal: FC<IGrillSelectionModalProps> = ({
	grillOptions,
	onConfirm,
	initialSelected = null,
	onClose,
}) => {
	const { t } = useTranslation();
	const [selected, setSelected] = useState<string | null>(initialSelected);

	const handleConfirm = () => {
		onConfirm(selected);
	};

	return (
		<PopupDialog
			open={true}
			onClose={onClose}
			data-testid="GrillSelectionModal"
			className="GrillSelectionModal"
			content={
				<div className="GrillSelectionContent">
					<div className="GrillSelectionTitle" data-testid="GrillSelectionTitle">
						{t("GrillSelectionModal.title")}
					</div>
					<div className="GrillSelectionButtons" data-testid="GrillSelectionButtons">
						{grillOptions.map((option) => (
							<button
								key={option.id}
								data-testid={`GrillOption-${option.id}`}
								className={`GrillOptionButton${selected === option.id ? " GrillOptionButtonSelected" : ""}`}
								onClick={() => setSelected(option.id)}
							>
								{option.label}
							</button>
						))}
					</div>
				</div>
			}
			buttons={[
				{
					text: t("GrillSelectionModal.confirm"),
					onClick: handleConfirm,
					className: "BtnGrillConfirm",
					disabled: selected === null,
				},
			]}
		/>
	);
};

export default GrillSelectionModal;
